<template>
  <popup
    title="Подача документов"

    :value="value"
    :styles="{'width': '800px'}"
    @input="$emit('input', $event)"
  >
    <template v-slot:content>
      <div class="documents">
        <template v-if="alreadyRegisteredError">
          <p><strong>Уважаемый абитуриент!</strong> Пользователь с таким email уже зарегистрирован в Личном кабинете абитуриента.
            <br/>
            Пожалуйста, авторизуйтесь и заполните анкету.
          </p>
        </template>
        <template v-else-if="unknownError">
          <p><strong>Уважаемый абитуриент!</strong> Возникла ошибка.
            <br/>
            Пожалуйста, зарегистрируйтесь в Личном кабинете абитуриента и заполните анкету.
          </p>
        </template>
        <template v-else>
          <p><strong>Уважаемый абитуриент!</strong> Для вас был создан персональный личный кабинет, где вы сможете завершить подачу документов.</p>
          <p><strong>Логин</strong> и <strong>пароль</strong> для входа отправлены на указанный вами e-mail.</p>
        </template>
      </div>
    </template>
    <template v-slot:footer>
      <a class="btn click-sound" v-if="alreadyRegisteredError" href="https://synergy.ru/filing_documents/authorization" target="_blank">Авторизация</a>
      <a class="btn click-sound" v-else-if="unknownError" href="https://synergy.ru/filing_documents/" target="_blank">Регистрация</a>
      <button
        v-else
        class="btn click-sound"
        @click="handleSubmitAction"
      >
        Завершить
      </button>
    </template>
  </popup>
</template>

<script>
  import Popup from '@/components/Popup'
  import axios from 'axios'

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    components: {
      Popup
    },
    data: function() {
      return {
        alreadyRegisteredError: false,
        unknownError: true
      };
    },
    watch: {
      value(newValue) {
        if(newValue) {  // display the pop-up
          this.sendDocuments();
        }
      }
    },
    methods: {
      sendDocuments() {
        const url = 'https://synergy.ru/rest/game?token=43402b1562278f36f49e81526969812df48b80e895de68fdd4b8fe2a0a7d9bf0';
        const user = this.$store.getters.getUser
        const fields = {
          'name': user.fio,
          'phone': user.phone,
          'email': user.email,
        }

        axios.put(url, fields, {withCredentials: true}).then((response) => {

          response = response.data;

          // user successfully registered
          if(response.success) {
            this.unknownError = false;
            this.alreadyRegisteredError = false;

            const redirectUrl = response.object.jwt.url;
            window.open(redirectUrl, '_blank');
          } else {
            if(response.message === 'User already exists') { // yes, this sucks, I know -_-

              // the user already exists in the database; redirect to portal
              this.alreadyRegisteredError = true;
            } else {

              // unknown error detected
              this.unknownError = true;
            }
          }
        });
      },
      handleSubmitAction() {
        this.alreadyRegisteredError = false;
        this.unknownError = false;
        this.$emit('continueQuest', true, 5);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .documents {

    p {
      margin-bottom: 30px;
      text-align: center;
      font-size: 23px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
